/* global $ */
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "../game/dashboard.css";
import { DateRangePicker } from "react-date-range";
import React, { Component } from "react";
import { Link } from "react-router-dom";

const RxSelectbox = global.rootRequire("components/shares/rxSelectbox").default;
const { MainTable } = global.rootRequire("components/shares/rxTemplates");
const { apiget, rxgetExchangeRate, getExchangeRate } = global.rootRequire("classes/request");
const { AdminBlock } = global.rootRequire("components/shares/rxTemplates");
const ulti = require("../game/dashboardUlti").default;

const rxu = global.rxu;

class ROASByGameComponent extends Component {
	constructor(props) {
		super(props);
		this.toDate = new Date();

		this.toDate1Ago = new Date();
		this.toDate1Ago.setDate(this.toDate1Ago.getDate() - 1);

		this.toDate3Ago = new Date();
		this.toDate3Ago.setDate(this.toDate3Ago.getDate() - 3);

		this.toDate7Ago = new Date();
		this.toDate7Ago.setDate(this.toDate7Ago.getDate() - 7);

		this.toDate15Ago = new Date();
		this.toDate15Ago.setDate(this.toDate15Ago.getDate() - 15);

		this.toDate30Ago = new Date();
		this.toDate30Ago.setDate(this.toDate30Ago.getDate() - 30);

		this.toDate90Ago = new Date();
		this.toDate90Ago.setDate(this.toDate30Ago.getDate() - 90);

		this.typeDashboard = [
			{ _id: 0, name: "Default", api: "api_overview" },
			{ _id: 1, name: "Custom", api: "api_overview" },
		];
		this.state = {
			data: [],
			dataDetailToday: [],
			dataSourceRevToday: [],
			dataDetailYesterday: [],
			dataSourceRevYesterday: [],
			gameOptions: [],
			studioOptions: [],
			id: rxu.get(this.props, "match.params.id"),
			selectionRange: {
				startDate: this.toDate30Ago,
				endDate: this.toDate,
				key: "selection",
			},
			selectedNation: [],
			selectedStudio: [],
			selectedGame: [],
			api_dashboard: "api_overview",
			is_active: 0,
			flags: {},
			loading: false,
			paging: { st_col: "cost", st_type: -1, pg_page: 1, pg_size: 100 },
		};
	}

	run(name, params) {
		if (params) {
			params.inthis = this;
		} else {
			params = this;
		}
		if (typeof this.props[name] !== "undefined" && typeof this.props[name] === "function") {
			return this.props[name](params);
		} else if (typeof this[name] !== "undefined" && typeof this[name] === "function") {
			return this[name]();
		}
	}

	toggle(flagname) {
		const flags = this.state.flags;
		flags[flagname] = flags[flagname] ? 0 : 1;
		this.setState({ flags: flags });
	}

	flag(flagname) {
		return rxu.get(this.state, ["flags", flagname], 0);
	}

	handleSelect(ranges) {
		this.clearCanvasDom();

		console.log(ranges.selection);

		this.setState(
			{
				selectionRange: ranges.selection,
			},
			() => {
				this.fetchDetail();
			}
		);
	}

	componentDidMount() {
		this.fetchDetail();
		this.fetchStudio();
		this.fetchGame();
		rxgetExchangeRate(true);
	}

	componentWillUnmount() {}

	static getDerivedStateFromProps(props, state) {
		const id = rxu.get(props, "match.params.id");
		const idOld = state.id;

		const navigated = id !== idOld;
		if (navigated) {
			return { idOld, id };
		}
		return null;
	}

	fetchStudio() {
		apiget(
			global.rxu.config.api_studio,
			{},
			{
				1: (json) => {
					this.setState({ studioOptions: json.data });
				},
			}
		);
	}

	fetchGame() {
		const params = {};
		if (this.state.selectedStudio && this.state.selectedStudio !== "") {
			params.searchin_studio = this.state.selectedStudio;
		}
		apiget(global.rxu.config.api_game, params, {
			1: (json) => {
				this.setState({ gameOptions: json.data });
			},
		});
	}

	fetchDetail() {
		apiget(
			global.rxu.config.api_report_roas_by_game,
			{
				...this.state.paging,
				startDate: this.state.selectionRange.startDate,
				endDate: this.state.selectionRange.endDate,
				studios: this.state.selectedStudio,
				gameIds: this.state.selectedGame,
			},
			{
				1: (json) => {
					this.setState({ dataDetailToday: json.data.data, dataDetailYesterday: json.data.databefore });
				},
			}
		);
	}

	onClickSort(e, stcol) {
		const paging = this.state.paging;
		paging.st_type = paging.st_col !== stcol ? -1 : -1 * paging.st_type;
		paging.st_col = stcol;
		this.setState({ paging: paging }, () => {
			this.fetchDetail();
		});
	}

	onBlurDatafilter(e, name) {
		clearTimeout(this.timerDatafilter);
		const paging = this.state.paging;
		paging["search_" + name] = e.target.value;
		this.setState({ paging: paging });

		this.timerDatafilter = setTimeout((e, name) => {
			this.fetchDetail();
		}, 500);
	}

	helpSortClass(stcol, extraclass) {
		extraclass = extraclass || [];
		let result = "";
		if (this.state.paging.st_col === stcol) {
			result = this.state.paging.st_type === 1 ? "rx-sort-asc" : "rx-sort-desc";
		}
		for (let i = 0; i < extraclass.length; i++) {
			result += " " + extraclass[i];
		}
		return result;
	}

	handleNationChange(event) {
		this.clearCanvasDom();
		this.setState({ selectedNation: event }, () => {
			this.fetchDetail();
		});
	}

	backToGame(e) {
		this.clearCanvasDom();
		window.history.back();
	}

	releaseCanvas(labelId) {
		let canvas = document.getElementById(labelId);
		if (canvas) {
			canvas.width = 1;
			canvas.height = 1;
			const ctx = canvas.getContext("2d");
			ctx && ctx.clearRect(0, 0, 1, 1);
		}
	}

	clearCanvasDom() {
		for (let i = 0; i < 8; i++) {
			let labelId = `chart_${i}`;
			this.releaseCanvas(labelId);
			if (typeof this[labelId] !== "undefined") {
				this[labelId].destroy();
			}
		}
	}

	onBlurDataValue(value, name) {
		if (name === "selectedStudio") {
			this.setState({ selectedStudio: value }, () => {
				this.fetchGame();
				this.fetchDetail();
			});
		} else {
			this.setState({ selectedGame: value }, () => {
				this.fetchDetail();
			});
		}
	}

	handleTypeDashboadChange(event) {
		this.clearCanvasDom();
		const apiDashboard = event === 0 ? "api_overview" : "api_overview";
		this.setState({ api_dashboard: apiDashboard, is_active: event }, () => {});
	}

	// R E N D E R S
	renderDaterangeSelect() {
		return (
			<select className="chart__select">
				<option value="1week"> Theo tuần</option>
				<option value="1mouth"> Theo tháng</option>
				<option value="1year"> Theo năm</option>
			</select>
		);
	}

	renderTable(vm) {
		return (
			<MainTable>
				<thead>
					{this.renderTableHead()}
					{this.renderTableHeadSearch()}
				</thead>
				<tbody>{this.renderTableBody()}</tbody>
			</MainTable>
		);
	}

	renderTableHead() {
		return (
			<tr>
				<th className="rxwidth--100">STT</th>
				<th className={this.helpSortClass("studio", ["rxwidth--100"])} onClick={(e) => this.onClickSort(e, "studio")}>
					Studio
				</th>
				<th className={this.helpSortClass("gameName", ["rxwidth--100"])} onClick={(e) => this.onClickSort(e, "gameName")}>
					Game
				</th>
				
				<th className={this.helpSortClass("cost", ["rxright"])} onClick={(e) => this.onClickSort(e, "cost")}>
					UA COST
				</th>
				<th className={this.helpSortClass("conversions_value", ["rxright"])} onClick={(e) => this.onClickSort(e, "conversions_value")}>
					Rev (new accumulated)
				</th>
				
				<th className={this.helpSortClass("avgroas1", ["rxright"])} onClick={(e) => this.onClickSort(e, "avgroas1")}>
					AvgROAS 1
				</th>
				<th className={this.helpSortClass("avgroas3", ["rxright"])} onClick={(e) => this.onClickSort(e, "avgroas3")}>
					AvgROAS 3
				</th>
				<th className={this.helpSortClass("avgroas7", ["rxright"])} onClick={(e) => this.onClickSort(e, "avgroas7")}>
					AvgROAS 7
				</th>
				<th className={this.helpSortClass("avgroas14", ["rxright"])} onClick={(e) => this.onClickSort(e, "avgroas14")}>
					AvgROAS 14
				</th>
				<th className={this.helpSortClass("avgroas30", ["rxright"])} onClick={(e) => this.onClickSort(e, "avgroas30")}>
					AvgROAS 30
				</th>
				<th className={this.helpSortClass("avgroas", ["rxright"])} onClick={(e) => this.onClickSort(e, "avgroas")}>
					Accumulated ROAS
				</th>
				
			</tr>
		);
	}

	renderTableHeadSearch() {
		return (
			<tr className="table-sm">
				<th className="" />
				<th className="">
					<input className="form-control form-control-sm" aria-label="column name: 'name' filter input" onKeyUp={(e) => this.onBlurDatafilter(e, "studio_name")} />
				</th>
				<th className="">
					<input className="form-control form-control-sm" aria-label="column name: 'name' filter input" onKeyUp={(e) => this.onBlurDatafilter(e, "name")} />
				</th>
				<th className="" />
				<th className="" /> 
				<th className="" />
				<th className="" />
				<th className="" />
				<th className="" />
				<th className="" />
				<th className="" />
			</tr>
		);
	}

	renderTableBody() {
		const dataDetail = this.state.dataDetailToday;
		const dataDetailYesterday = this.state.dataDetailYesterday;
		const exchangeRate = getExchangeRate();

		return global.rxu.array(dataDetail).map((perdata, i) => {
			let perRev = 0;
			let perCost = 0;

			let perAvgroas1 = 0;
			let perAvgroas3 = 0;
			let perAvgroas7 = 0;
			let perAvgroas14 = 0;
			let perAvgroas30 = 0;
			let perRoas = 0;

			let dataDetailAgo = [];
			console.log("dataDetailYesterday", dataDetailYesterday);
			if (dataDetailYesterday && dataDetailYesterday.length > 0) {
				dataDetailAgo = dataDetailYesterday.filter((x) => x.gameId === perdata.gameId);
				console.log("dataDetailAgo", dataDetailAgo);
				perRev = ulti.number_format_(((perdata?.conversions_value - dataDetailAgo[0]?.conversions_value) / dataDetailAgo[0]?.conversions_value) * 100);
				perCost = ulti.number_format_(((perdata?.cost / exchangeRate - dataDetailAgo[0]?.cost / exchangeRate) / (dataDetailAgo[0]?.cost / exchangeRate)) * 100);	
				perAvgroas1 = (perdata?.avgroas1 > 0) ? ulti.number_format_(((perdata?.avgroas1 - dataDetailAgo[0]?.avgroas1) / dataDetailAgo[0]?.avgroas1) * 100) : 0;
				perAvgroas3 = (perdata?.avgroas3 > 0) ? ulti.number_format_(((perdata?.avgroas3 - dataDetailAgo[0]?.avgroas3) / dataDetailAgo[0]?.avgroas3) * 100) : 0;
				perAvgroas7 = (perdata?.avgroas7 > 0) ? ulti.number_format_(((perdata?.avgroas7 - dataDetailAgo[0]?.avgroas7) / dataDetailAgo[0]?.avgroas7) * 100) : 0;
				perAvgroas14 = (perdata?.avgroas14 > 0) ? ulti.number_format_(((perdata?.avgroas14 - dataDetailAgo[0]?.avgroas14) / dataDetailAgo[0]?.avgroas14) * 100) : 0;
				perAvgroas30 = (perdata?.avgroas30 > 0) ? ulti.number_format_(((perdata?.avgroas30 - dataDetailAgo[0]?.avgroas30) / dataDetailAgo[0]?.avgroas30) * 100) : 0;
				perRoas = (perdata?.avgroas > 0) ? ulti.number_format_(((perdata?.avgroas - dataDetailAgo[0]?.avgroas) / dataDetailAgo[0]?.avgroas) * 100) : 0;
			}
			console.log("perdata", perdata);

			return (
				<tr className="" key={perdata.gameId}>
					<td>{Number(i) + 1}</td>
					<td>{global.rxu.get(perdata, "studioName", "")}</td>
					<td className="betable__gamelink">
						<Link to={`/admin/dashboard/${global.rxu.get(perdata, "id", "") || 123}`}>{global.rxu.get(perdata, "name", "")}</Link>
					</td>
					<td className="rxright">
						<small className="rxtop">{ulti.number_format_(perdata.cost / exchangeRate)}</small>
						<br />
						<small className={perCost < 0 ? "rxbottom rxdown" : "rxbottom rxup"}>{!isNaN(perCost) ? perCost : ""} %</small>
					</td>
					<td className="rxright">
						<small className="rxtop">{ulti.number_format_(perdata.conversions_value / exchangeRate)}</small>
						<br />
						<small className={perRev < 0 ? "rxbottom rxdown" : "rxbottom rxup"}>{!isNaN(perRev) ? perRev : ""} %</small>
					</td>
					<td className="rxright">
						<small className="rxtop">{ulti.number_format_(perdata.avgroas1 * 100)}</small>
						<br />
						<small className={perAvgroas1 < 0 ? "rxbottom rxdown" : "rxbottom rxup"}>{!isNaN(perAvgroas1) ? perAvgroas1 : ""} %</small>
					</td>
					<td className="rxright">
						<small className="rxtop">{ulti.number_format_(perdata.avgroas3 * 100)}</small>
						<br />
						<small className={perAvgroas3 < 0 ? "rxbottom rxdown" : "rxbottom rxup"}>{!isNaN(perAvgroas3) ? perAvgroas3 : ""} %</small>
					</td>
					<td className="rxright">
						<small className="rxtop">{ulti.number_format_(perdata.avgroas7 * 100)}</small>
						<br />
						<small className={perAvgroas7 < 0 ? "rxbottom rxdown" : "rxbottom rxup"}>{!isNaN(perAvgroas7) ? perAvgroas7 : ""} %</small>
					</td>
					<td className="rxright">
						<small className="rxtop">{ulti.number_format_(perdata.avgroas14 * 100)}</small>
						<br />
						<small className={perAvgroas14 < 0 ? "rxbottom rxdown" : "rxbottom rxup"}>{!isNaN(perAvgroas14) ? perAvgroas14 : ""} %</small>
					</td>
					<td className="rxright">
						<small className="rxtop">{ulti.number_format_(perdata.avgroas30 * 100)}</small>
						<br />
						<small className={perAvgroas30 < 0 ? "rxbottom rxdown" : "rxbottom rxup"}>{!isNaN(perAvgroas30) ? perAvgroas30 : ""} %</small>
					</td>
					<td className="rxright">
						<small className="rxtop">{ulti.number_format_(perdata.avgroas * 100)}</small>
						<br />
						<small className={perRoas < 0 ? "rxbottom rxdown" : "rxbottom rxup"}>{!isNaN(perRoas) ? perRoas : ""} %</small>
					</td>
				</tr>
			);
		});
	}

	render() {
		return (
			<>
				{this.state.loading && (
					<div className="bg_loading">
						<div className="rxloading"></div>
					</div>
				)}
				<AdminBlock name={"Dashboard " + rxu.get(this.state, "data.name")} desc={"Dashboard " + rxu.get(this.state, "data.desc")} exclass="adsticky">
					<div className="row">
						<div className="filtersum__block">
							<div className="showFilterBtn attop icon-magnifier-add" />
							<div className="filtersum__nation">
								<b>Nation</b> {rxu.array(this.state.selectedNation.map((e) => e.value)).join(",") || "All"}
							</div>
							<div className="filtersum__date">
								<b>Date</b> {this.state.selectionRange.startDate.toLocaleDateString("vi-VN")} - {this.state.selectionRange.endDate.toLocaleDateString("vi-VN")}{" "}
							</div>
						</div>
					</div>
					<div className="showFilterBtn icon-magnifier-add" />
					<div className="showFilter">
						<div className="filterWrap">
							<div className="filterLabel">Type Dashboard</div>
							<div className="tabSelect">
								<div className="tabSelectLabel">
									<span className={Number(this.state.is_active) === 0 ? "tabSelectItem tabSelectItemActive" : "tabSelectItem"} onClick={(e) => this.handleTypeDashboadChange(0)}>
										Default
									</span>
								</div>
								<div className="tabSelectLabel">
									<span className={Number(this.state.is_active) === 1 ? "tabSelectItem tabSelectItemActive" : "tabSelectItem"} onClick={(e) => this.handleTypeDashboadChange(1)}>
										Custom
									</span>
								</div>
							</div>
							<div className="filterLabel">Nation</div>
							{/* <MultiSelect options={ulti.countryOptions} value={this.state.selectedNation} onChange={this.handleNationChange.bind(this)} labelledBy='Select' /> */}
							<div className="filterLabel">Studio</div>
							{this.state.studioOptions && this.state.studioOptions.length !== 0 && (
								<RxSelectbox
									multi={false}
									options={this.state.studioOptions}
									results={this.state.selectedStudio}
									onChange={(result) => {
										this.onBlurDataValue(result, "selectedStudio");
									}}
								/>
							)}
							<div className="filterLabel">Game</div>
							{this.state.gameOptions && this.state.gameOptions.length !== 0 && (
								<RxSelectbox
									multi
									options={this.state.gameOptions}
									results={this.state.selectedGame}
									onChange={(result) => {
										this.onBlurDataValue(result, "selectedGame");
									}}
								/>
							)}
							<div className="filterLabel">Date</div>
							<DateRangePicker
								staticRanges={[
									{
										...staticRangeHandler,
										label: "Today",
										range: () => ({ startDate: this.toDate, endDate: this.toDate }),
									},
									{
										...staticRangeHandler,
										label: "Yesterday",
										range: () => ({ startDate: this.toDate1Ago, endDate: this.toDate1Ago }),
									},
									{
										...staticRangeHandler,
										label: "Last 3 days",
										range: () => ({ startDate: this.toDate3Ago, endDate: this.toDate1Ago }),
									},
									{
										...staticRangeHandler,
										label: "Last 7 days",
										range: () => ({ startDate: this.toDate7Ago, endDate: this.toDate1Ago }),
									},
									{
										...staticRangeHandler,
										label: "Last 15 days",
										range: () => ({ startDate: this.toDate15Ago, endDate: this.toDate1Ago }),
									},
									{
										...staticRangeHandler,
										label: "Last 30 days",
										range: () => ({ startDate: this.toDate30Ago, endDate: this.toDate1Ago }),
									},
									{
										...staticRangeHandler,
										label: "Last 90 days",
										range: () => ({ startDate: this.toDate90Ago, endDate: this.toDate1Ago }),
									},
								]}
								ranges={[this.state.selectionRange]}
								onChange={this.handleSelect.bind(this)}
							/>
						</div>
					</div>

					<div className="rxcol-100">
						<div className="betable">
							<div className="adblock__head ">
								<div className="adblock__title">Bảng report ROAS by game </div>
								<div className="adblock__desc" />
							</div>
							{this.renderTable()}
						</div>
					</div>
				</AdminBlock>
			</>
		);
	}
}

const staticRangeHandler = {
	range: {},
	isSelected(range) {
		const definedRange = this.range();
		return isSameDay(range.startDate, definedRange.startDate) && isSameDay(range.endDate, definedRange.endDate);
	},
};

function isSameDay(date1, date2) {
	try {
		return date1.toString() === date2.toString();
	} catch (e) {
		return false;
	}
}

export default ROASByGameComponent;
